import React, {useMemo} from "react";
import {Stack, TextField} from "@mui/material";
import {HibobOfficeForm, WorkSite} from "../../api/Model";
import {formPatcher, inputChange, mapSetState, SetState} from "../../util/FormHandlers";
import ColorPicker from "../../components/color-picker/ColorPicker";
import {SiteSelect} from "../../components/site-select/SiteSelect";

export type HibobResidenceOfficeForm = Omit<HibobOfficeForm, 'workSiteId'> & {workSite: WorkSite | null};

export function HibobResidenceOfficeFormDialog({form, setForm}: {
    form: HibobResidenceOfficeForm,
    setForm: SetState<HibobResidenceOfficeForm>,
}) {
    const setWorkSite = useMemo(() => mapSetState(setForm, 'workSite'), [setForm]);
    const handlers = useMemo(() => ({
        handleBadgeChange: inputChange(setForm, newValue => ({
            badge: newValue || undefined,
        })),
        handleColorChange: formPatcher(setForm, (newValue: string) => ({
            color: newValue || undefined,
        })),
    }), [setForm]);

    return (
        <Stack spacing={2} direction="column" sx={{pt: 2}}>
            <TextField
                autoFocus
                margin="dense"
                id="badge"
                label="Badge"
                type="text"
                fullWidth
                variant="outlined"
                value={form.badge || ''}
                onChange={handlers.handleBadgeChange}
            />
            <ColorPicker
                clearable
                margin="dense"
                id="color"
                label="Color"
                fullWidth
                variant="outlined"
                value={form.color}
                onChange={handlers.handleColorChange}
                slotProps={{inputLabel: {shrink: true}}}
            />
            <SiteSelect
                site={form.workSite}
                setSite={setWorkSite}
                label="Parent Work Site"
                helperText="Clear the selection to leave the work site undefined. Without a custom color, the badge uses the parent work site's color."
                margin="normal"
                fullWidth
            />
        </Stack>
    );
}
